import * as XLSX from 'xlsx';

interface ExportXlsxSheet {
  name: string;
  data: {
    [key: string]: string | number | Date;
  }[];
}

interface ExportXlsxProps {
  data?: {
    [key: string]: string | number | Date;
  }[];
  sheets?: ExportXlsxSheet[];
  filename: string;
}

export default function ExportXlsx({ data, sheets, filename }: ExportXlsxProps) {
  const workbook = XLSX.utils.book_new();

  if (sheets && sheets.length > 0) {
    sheets.forEach((sheet) => {
      const worksheet = XLSX.utils.json_to_sheet(sheet.data);
      XLSX.utils.book_append_sheet(workbook, worksheet, sheet.name);
    });
  } else if (data) {
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Planilha 1');
  }

  XLSX.writeFile(workbook, `${filename}.xlsx`);
}
